import {useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {createUserName} from '@/components/header/utils/create-user-name';
import {useAuth} from '@/services/auth';
import {Header as HeaderUIKit} from '@/ui-kit';
import {useUser} from './use-user';
import styles from './header.module.scss';

export const Header = () => {
  const {user} = useUser();
  const {logout} = useAuth();
  const navigate = useNavigate();

  const profile = useMemo(() => {
    if (user?.firstName) {
      const {firstName, lastName = ''} = user;

      return {
        user: {
          name: createUserName(firstName, lastName),
          links: [
            {
              id: 'logout',
              label: 'Logout',
              onClick: () => logout(),
            },
          ],
        },
      };
    }

    return null;
  }, [logout, user]);

  return (
    <>
      <HeaderUIKit
        showTitleAbove="sm"
        className={styles.header}
        title="PayerHub"
        showMenu={false}
        profile={profile}
        onLogoClick={() => navigate('/')}
      />
    </>
  );
};
